import { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';

import { clearAuth, getUser, isAdmin } from '../api.js';
import ChangePassword from './ChangePassword.jsx';

const BASE_LINKS = [
    { to: '/', label: 'Dashboard', end: true },
    { to: '/mandanten', label: 'Mandanten' },
    { to: '/events', label: 'Ereignisse' },
    { to: '/kurseinstellungen', label: 'Kurseinstellungen' },
    { to: '/totara', label: 'Totara' },
];

const ADMIN_LINKS = [{ to: '/users', label: 'Benutzer' }];

export default function Sidebar() {
    const navigate = useNavigate();
    const user = getUser();
    const admin = isAdmin();
    const [showChangePw, setShowChangePw] = useState(false);

    const links = admin ? [...BASE_LINKS, ...ADMIN_LINKS] : BASE_LINKS;

    function handleLogout() {
        clearAuth();
        navigate('/login');
    }

    return (
        <aside className="sidebar">
            <div className="sidebar__brand">LMS Admin</div>
            <nav>
                {links.map((l) => (
                    <NavLink
                        key={l.to}
                        to={l.to}
                        end={l.end}
                        className={({ isActive }) =>
                            'sidebar__link' + (isActive ? ' is-active' : '')
                        }
                    >
                        {l.label}
                    </NavLink>
                ))}
            </nav>
            <div className="sidebar__user">
                Angemeldet als <strong>{user || '–'}</strong>
                {admin && (
                    <div style={{ fontSize: 12, opacity: 0.7, marginTop: 2 }}>Admin</div>
                )}
                <button
                    type="button"
                    className="sidebar__logout"
                    onClick={() => setShowChangePw(true)}
                    style={{ marginBottom: 6 }}
                >
                    Passwort ändern
                </button>
                <button type="button" className="sidebar__logout" onClick={handleLogout}>
                    Abmelden
                </button>
            </div>
            {showChangePw && <ChangePassword onClose={() => setShowChangePw(false)} />}
        </aside>
    );
}
